export const genderOptions = [
  {
    value: 'MALE',
    name: 'Male',
  },
  {
    value: 'FEMALE',
    name: 'Female',
  },
  {
    value: 'TRANSGENDER',
    name: 'Transgender',
  },
  {
    value: 'INTERSEX',
    name: 'Intersex',
  },
  {
    value: 'NON_BINARY',
    name: 'Non Binary',
  },
  {
    value: 'PREFER_NOT_TO_SAY',
    name: 'Prefer not to say',
  },
  {
    value: 'OTHER',
    name: 'Other',
  },
]

export const CountryCode = [
  {
    id: '1',
    value: '+91',
  },
]
